const env = {
  MODE: import.meta.env.MODE,
  API_URL: import.meta.env.VITE_API_URL
    ? import.meta.env.VITE_API_URL
    : `${window.location.protocol}//${window.location.hostname}:5000`,
  API_LOGIN_PATH: import.meta.env.VITE_LOGIN_PATH,
  API_REFRESH_PATH: import.meta.env.VITE_LOGIN_PATH,

  RECAPTCHA_PUBLIC_KEY: import.meta.env.VITE_RECAPTCHA_PUBLIC_KEY,

  WS_URL:
    import.meta.env.VITE_WS_URL ||
    `${window.location.protocol}//${window.location.hostname}:5000`,
};

export default env;
